import { pathWithParams } from '#/utils/url/pathWithParams';

export type ImportedListingSource = 'NYCPARKS' | 'GOLDEN' | 'IDEALIST';

export function getImportedListingUrl(url: string) {
  return pathWithParams(url, {
    utm_medium: 'referral',
    utm_source: 'idealist',
    utm_campaign: 'action_opportunities',
  });
}
